import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { adminLogin } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("pennymacs_token", res.data.token);
      localStorage.setItem("pennymacs_email", res.data.email);
      toast.success("Welcome back!");
      onLogin(res.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#f5f5f7] flex items-center justify-center px-4"
    >
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-12 h-12 rounded-full bg-[#1d1d1f] flex items-center justify-center mx-auto mb-4">
              <Lock className="w-5 h-5 text-white" />
            </div>
            <h1 className="text-xl font-bold text-[#1d1d1f] tracking-tight">
              Admin Login
            </h1>
            <p className="mt-1 text-sm text-[#86868b]">
              PennyMacs Dashboard
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-[#1d1d1f] block mb-1.5">
                Email
              </label>
              <Input
                data-testid="login-email-input"
                type="email"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-[#1d1d1f] block mb-1.5">
                Password
              </label>
              <Input
                data-testid="login-password-input"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-full h-11 text-sm font-semibold bg-[#1d1d1f] hover:bg-[#1d1d1f]/90"
              data-testid="login-submit-btn"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
        <p className="text-center mt-6 text-xs text-[#86868b]">
          Protected area. Authorized personnel only.
        </p>
      </div>
    </div>
  );
}
